import { LoggedUser } from "../../../redux/store";
import { Account } from "@idha/idha-types";
import * as R from "ramda";
import { ModulePermissions, PermissionsPipeData } from "./base-classes";
import { hasRole } from "redux/helperFunctions/loggedUser.helperFunctions";

export class PackingAccessPermissions extends ModulePermissions {
  inputPackages: boolean = true;
  outputPackages: boolean = true;
  sceduleWithdraw: boolean = true;
  scheduleLogistics: boolean = true;
  inputDamagedPackages: boolean = true;
  transferToDagamedPackages: boolean = true;
  transferToRecyclePackages: boolean = true;
  transferToMovimentationPackages: boolean = true;
  seeStatement: boolean = true;
  seeSanitizationReports: boolean = false; //@TODO NEGADO temporariamente, na issue idha/idha#381. Quando for iniciar a utilização do laudo, mudar esta opção para TRUE
  transferenceCoupons: boolean = true;
  antecipateCompensations: boolean = false; //@TODO NEGADO temporariamente, na issue idha/idha#1071. Por hora não permitiremos antecipacao de creditos. Liberar novamente quando for necessario
  seeWithdrawSchedules: boolean = true;
  confirmWithdrawSchedules: boolean = true;
  cancelWithdrawSchedules: boolean = true;
  checkInWithdrawSchedules: boolean = true;
  checkOutWithdrawSchedules: boolean = true;
  checkAgencyStatement: boolean = true;
  checkAgenciesStatement: boolean = true;
  requestCreditLimit: boolean = true;
  manageAdministrativeUnits: boolean = true;
  grantCreditLimit: boolean = true;
  locationManagement: boolean = true;
  manageBankSettings: boolean = true;
  manageSanitizationFee: boolean = true;
  manageSanitizationStep: boolean = true;
  managerPackingModels: boolean = true;
  idhaAdminPersonManagement: boolean = false;
  seeRegistrationMenu: boolean = true;
  paymentMethodManagment: boolean = true;
  paymentModalityManagment: boolean = true;
  agencyReports?:boolean = false
  bankReports?:boolean = false
  accessAgencyAccount?:boolean = true;
  accessBankAccount?: boolean = true;
  constructor() {
    super();
  }
}

export class PackingPermissionsPipeData extends PermissionsPipeData<
  PackingAccessPermissions
> {
  account: Account;

  constructor(
    loggedUser: LoggedUser,
    account: Pick<Account, "id" | "accountType" | "bank">
  ) {  .0
    super(loggedUser, new PackingAccessPermissions());
    this.account = account;
  }
}

namespace AccessRules {
  export function idhaAdmin(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {

    const isIdhaAdmin = hasRole(data.loggedUser,"idhaAdmin")
    
    data.permissions.manageAdministrativeUnits = isIdhaAdmin;    
    data.permissions.idhaAdminPersonManagement = isIdhaAdmin;    
    data.permissions.manageSanitizationFee = isIdhaAdmin;
    data.permissions.managerPackingModels = isIdhaAdmin;
    data.permissions.checkAgenciesStatement = isIdhaAdmin
    
    return data;
  }

  export function accountNotInformed(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (!data.account) {
      data.disableAllKeys();
    }

    return data;
  }

  export function accountTypeAgency(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (data.account?.accountType == "AGENCY") {
      data.permissions = {
        ...data.permissions,
        antecipateCompensations: false,
        inputDamagedPackages: false,
        inputPackages: false,
        outputPackages: false,
        sceduleWithdraw: false,
        scheduleLogistics: false,
        transferToDagamedPackages: false,
        transferToMovimentationPackages: false,
        transferToRecyclePackages: false,
        transferenceCoupons: false,
        seeWithdrawSchedules: false,
        seeSanitizationReports: false,
        requestCreditLimit: false,
        confirmWithdrawSchedules: false,
        checkInWithdrawSchedules: false,
        cancelWithdrawSchedules: false,
        checkOutWithdrawSchedules: false,
        locationManagement: false,
        manageBankSettings: false,
        manageSanitizationStep: false,
        paymentMethodManagment: false,
        paymentModalityManagment: false,
        agencyReports: true
      };
      if (!data.account?.agencyThatOwns?.agencyRules?.allowGrantCreditLimit) {
        data.permissions.grantCreditLimit = false;
      }
    }
    return data;
  }

  export function accountTypeBank(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (data.account?.accountType == "BANK") {
      data.permissions = {
        ...data.permissions,
        antecipateCompensations: false,
        sceduleWithdraw: false,
        scheduleLogistics: false,
        transferenceCoupons: false,
        checkAgencyStatement: false,
        seeSanitizationReports: false,
        requestCreditLimit: false,
        grantCreditLimit: false,
        manageSanitizationStep: true,
        bankReports: true,

      
      };
    }
    return data;
  }

  export function accountTypeAccountant(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (
      data.account?.accountType != "BANK" &&
      data.account?.accountType != "AGENCY"
    ) {
      if (
        data.account?.agencyThatAdminister?.agencyRules?.agencyStatus == "SETUP"
      ) {
        data.disableAllKeys(); //Se a agencia nao estiver autorizada a iniciar, os correntistas nao podem desempenhar tarefas
      } else {
        data.permissions = {
          ...data.permissions,
          transferToDagamedPackages: false,
          transferToMovimentationPackages: false,
          transferToRecyclePackages: false,
          inputDamagedPackages: false,
          seeWithdrawSchedules: false,
          checkAgencyStatement: false,
          grantCreditLimit: false,
          confirmWithdrawSchedules: false,
          checkInWithdrawSchedules: false,
          checkOutWithdrawSchedules: false,
          cancelWithdrawSchedules: false,
          requestCreditLimit:
            data.account?.agencyThatAdminister?.agencyRules
              ?.allowGrantCreditLimit,
          locationManagement: false,
          manageBankSettings: false,
          manageSanitizationStep: false,
          paymentMethodManagment: false,
          paymentModalityManagment: false
        };
      }
    }
    return data;
  }

  export function accountTypeShippingCompany(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (data.account?.accountType == "SHIPPING_COMPANY") {
      data.permissions = {
        ...data.permissions,
        scheduleLogistics: false,
      };
    }
    return data;
  }

  export function accountTypeStartUser(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (["PRODUCER", "PACKER"].includes(data.account?.accountType)) {
      data.permissions = {
        ...data.permissions,
      };
    }
    return data;
  }

  export function accountTypeIntermediateUser(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (["DISTRIBUTOR", "WHOLESALER"].includes(data.account?.accountType)) {
      data.permissions = {
        ...data.permissions,
      };
    }
    return data;
  }

  export function accountTypeEndUser(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (data.account?.accountType == "RETAILER") {
      data.permissions = {
        ...data.permissions,
        outputPackages: false,
        transferenceCoupons: false,
      };
    }
    return data;
  }

  export function accountTypeOther(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (data.account?.accountType == "OTHER") {
      data.disableAllKeys();
    }

    return data;
  }

  export function role(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (hasRole(data.loggedUser,"admin")) return data;

    data.permissions.transferenceCoupons = false;
    data.permissions.checkAgencyStatement = false;
    data.permissions.checkAgenciesStatement = false;
    data.permissions.cancelWithdrawSchedules = false;

    data.permissions.requestCreditLimit = false;
    data.permissions.locationManagement = false;
    data.permissions.manageBankSettings = false;
    
    if (
      !hasRole(data.loggedUser,"packing.accountOperator.agency")
    ) {
      if (data.account?.accountType == "AGENCY") {
        data.permissions.accessAgencyAccount = false;
      }
    }
    
    if (
      !hasRole(data.loggedUser,"packing.accountOperator.bank")
    ) {
      if (data.account?.accountType == "BANK") {
        data.permissions.outputPackages = false;
        data.permissions.confirmWithdrawSchedules = false;
        data.permissions.checkInWithdrawSchedules = false;
        data.permissions.accessBankAccount = false;
      }
    }
    
    if (
      !hasRole(data.loggedUser,"packing.outputChecker") &&
      !hasRole(data.loggedUser,"packing.cashier")
    ) {
      data.permissions.seeWithdrawSchedules = false;
    }

    if (!hasRole(data.loggedUser,"packing.outputChecker")) {
      if (data.account?.accountType != "BANK") {
        data.permissions.outputPackages = false;
      } else {
        data.permissions.checkOutWithdrawSchedules = false;
      }
    }
    if (!hasRole(data.loggedUser,"packing.cashier")) {
      if (data.account?.accountType == "BANK") {
        data.permissions.outputPackages = false;
        data.permissions.confirmWithdrawSchedules = false;
        data.permissions.checkInWithdrawSchedules = false;
      }
    }
    if (!hasRole(data.loggedUser,"packing.inputChecker")) {
      data.permissions.inputDamagedPackages = false;
      data.permissions.inputPackages = false;
      data.permissions.transferToRecyclePackages = false;
      data.permissions.transferToDagamedPackages = false;
      data.permissions.transferToMovimentationPackages = false; 
    }

    if (!hasRole(data.loggedUser,"admin")) {
      data.permissions.locationManagement = false;
      data.permissions.manageBankSettings = false;
      data.permissions.manageSanitizationStep = false;
    }      

    return data;
  }

  export function sanitizerInnerAccounts(
    data: PackingPermissionsPipeData
  ): PackingPermissionsPipeData {
    if (data.account?.accountType != "BANK") return data;
    if (!data.account?.bank) {
      console.error(
        "A instância do banco/higieniador deve ser incluída na instância da conta para verificação da regra de acesso"
      );
      data.disableAllKeys();
      return data;
    }

    if (isMovimentationAccount(data.account)) {
      data.permissions = {
        ...data.permissions,
        transferToMovimentationPackages: false,
        transferToRecyclePackages: false,
      };
      return data;
    }

    if (isDamagedAccount(data.account)) {
      data.permissions = {
        ...data.permissions,
        transferToMovimentationPackages: false,
        transferToDagamedPackages: false,
        inputPackages: false,
        outputPackages: false,
      };
      return data;
    }

    if (isRecycleAccount(data.account)) {
      data.permissions = {
        ...data.permissions,
        transferToDagamedPackages: false,
        transferToRecyclePackages: false,
        inputPackages: false,
        outputPackages: false,
        inputDamagedPackages: false,
      };
    }

    return data;

    function isMovimentationAccount(account: Account) {
      if (!account.bank?.movimentationAccountId) return false;
      if (!account?.id) return false;
      return (
        account.bank.movimentationAccountId.toString() == account.id.toString()
      );
    }
    function isRecycleAccount(account: Account) {
      if (!account.bank?.recyclingAccountId) return false;
      if (!account?.id) return false;
      return (
        account.bank.recyclingAccountId.toString() == account.id.toString()
      );
    }
    function isDamagedAccount(account: Account) {
      if (!account.bank?.damagedPackagesAccountId) return false;
      if (!account?.id) return false;
      return (
        account.bank?.damagedPackagesAccountId.toString() ==
        account.id.toString()
      );
    }
  }

  export function  seeRegistrationMenu(data: PackingPermissionsPipeData):PackingPermissionsPipeData{
        
    if(!(data.permissions.managerPackingModels || data.permissions.locationManagement || data.permissions.manageSanitizationStep)){
        data.permissions.seeRegistrationMenu = false
    }

    return data
}

  export function end(
    data: PackingPermissionsPipeData
  ): PackingAccessPermissions {
    return data.permissions;
  }
}

export default R.pipe(
  AccessRules.idhaAdmin,
  AccessRules.accountNotInformed,
  R.pipe(
    AccessRules.accountTypeAgency,
    AccessRules.accountTypeBank,
    AccessRules.accountTypeAccountant,
    AccessRules.accountTypeShippingCompany,
    AccessRules.accountTypeOther,
    AccessRules.accountTypeStartUser,
    AccessRules.accountTypeIntermediateUser,
    AccessRules.accountTypeEndUser,
    AccessRules.sanitizerInnerAccounts
    ),
    AccessRules.role,
    AccessRules.seeRegistrationMenu,
  AccessRules.end
);
